// extracted by mini-css-extract-plugin
module.exports = {"articleWrapper":"style_articleWrapper__2m2Su","articleContainer":"style_articleContainer__2-F-A","actionError":"style_actionError__1VzMM"};